import React, { useEffect } from "react"
import { useRouter } from "next/router"
import useAccount from "@/hooks/api-hooks/useAccount"
import LoggedOutLayout from "@/components/layouts/LoggedOutLayout"
import styles from "@/styles/LoggedOutLayout.module.scss"
import typo from "@/styles/Typography.module.scss"
import colors from "@/styles/Colors.module.scss"
import { postLogout } from "@/api/nextme/login"
import classNames from "classnames"
import { resetSelectedSlice } from "@/store/slices/selectedSlice"
import { useDispatch } from "react-redux"
import useAnalytics from "@/hooks/useAnalytics"
import dynamic from "next/dynamic"
import loader from "public/animations/loader-blue.json"

const Lottie = dynamic(() => import('react-lottie-player/dist/LottiePlayerLight'), { ssr: false })

export default function LogoutPage() {
  const router = useRouter()
  const dispatch = useDispatch()
  const { mutateAccount } = useAccount(true)
  const { analytics } = useAnalytics(true)

  const handleLogout = async () => {
    localStorage.clear()

    await mutateAccount(null)
    analytics.reset()

    dispatch(resetSelectedSlice())
  }

  useEffect(() => {
    postLogout()
      .then(handleLogout)
      .then(() => {
        //* give it a few seconds to make sure the logout actually happened
        setTimeout(() => {
          router.replace("/")
        }, 1000)
      })
  }, [dispatch, router])

  return (
    <LoggedOutLayout title="Logging Out...">
      <main className={styles.body}>
        <div className={styles.center}>
          <Lottie 
            animationData={loader} 
            style={{ height: 100, width: 100 }} 
            loop
            play
          />
          <h4 className={classNames(typo.h4, colors.slate)}>
            You have been logged out.
          </h4>
          <p>Redirecting you to the home page...</p>
        </div>

      </main>
    </LoggedOutLayout>
  )
}
